/** Support contact information displayed in the OptiBot panel header. */
export const SUPPORT_PHONE_TEL = '+18324108132';
export const SUPPORT_EMAIL = 'support@optisigns.com';

/** Maximum character limit for chat input. */
export const MAX_INPUT_LENGTH = 2000;

/** Request timeout for chat API calls (45 seconds). */
export const CHAT_REQUEST_TIMEOUT_MS = 45_000;

/** Shared OptiBot brand gradient used by the FAB and BotAvatar. */
export const OPTIBOT_GRADIENT = 'linear-gradient(160deg, #00D06E 25%, #1ED1CE 55%)';

/** Derive the chat API URL from the GraphQL URL environment variable. */
export function getChatApiUrl(): string {
  const graphqlUrl = import.meta.env.VITE_GRAPHQL_URL || '';
  return graphqlUrl.replace(/\/graphql$/, '') + '/api/chat';
}
